package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Australia Flag (32x24dp)
 *
 * - ISO Alpha-2: AU
 * - ISO Alpha-3: AUS
 * - ISO Numeric: 016
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Australia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Australia:AU:AUS:016:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-2.004f, 13f)
                lineTo(1.957f, 14.737f)
                lineTo(18.09f, 1.889f)
                lineTo(20.179f, -0.693f)
                lineTo(15.943f, -1.273f)
                lineTo(9.363f, 4.263f)
                lineTo(4.067f, 7.994f)
                lineTo(-2.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.462f, 14.217f)
                lineTo(0.556f, 15.225f)
                lineTo(19.429f, -0.933f)
                horizontalLineTo(16.596f)
                lineTo(-1.462f, 14.217f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(20.004f, 13f)
                lineTo(16.043f, 14.737f)
                lineTo(-0.09f, 1.889f)
                lineTo(-2.179f, -0.693f)
                lineTo(2.056f, -1.273f)
                lineTo(8.637f, 4.263f)
                lineTo(13.933f, 7.994f)
                lineTo(20.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(19.869f, 13.873f)
                lineTo(17.851f, 14.882f)
                lineTo(9.815f, 7.964f)
                lineTo(7.432f, 7.191f)
                lineTo(-2.38f, -0.684f)
                horizontalLineTo(0.453f)
                lineTo(10.26f, 7.004f)
                lineTo(12.865f, 7.931f)
                lineTo(19.869f, 13.873f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.985f, 0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.485f, 0f)
                horizontalLineTo(11.484f)
                verticalLineTo(4.5f)
                horizontalLineTo(18f)
                verticalLineTo(9.5f)
                horizontalLineTo(11.484f)
                lineTo(11.5f, 14f)
                horizontalLineTo(6.5f)
                lineTo(6.485f, 9.5f)
                horizontalLineTo(0f)
                verticalLineTo(4.5f)
                horizontalLineTo(6.485f)
                verticalLineTo(0f)
                close()
                moveTo(7.985f, 6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(6f, 2f)
                horizontalLineToRelative(25f)
                verticalLineToRelative(21f)
                horizontalLineToRelative(-25f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(9f, 20.5f)
                lineTo(7.698f, 21.703f)
                lineTo(7.827f, 19.935f)
                lineTo(6.075f, 19.668f)
                lineTo(7.538f, 18.666f)
                lineTo(6.655f, 17.129f)
                lineTo(8.349f, 17.649f)
                lineTo(9f, 16f)
                lineTo(9.651f, 17.649f)
                lineTo(11.345f, 17.129f)
                lineTo(10.462f, 18.666f)
                lineTo(11.925f, 19.668f)
                lineTo(10.173f, 19.935f)
                lineTo(10.302f, 21.703f)
                lineTo(9f, 20.5f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(22f, 13f)
                lineTo(21.132f, 13.802f)
                lineTo(21.218f, 12.623f)
                lineTo(20.05f, 12.445f)
                lineTo(21.025f, 11.778f)
                lineTo(20.436f, 10.753f)
                lineTo(21.566f, 11.099f)
                lineTo(22f, 10f)
                lineTo(22.434f, 11.099f)
                lineTo(23.564f, 10.753f)
                lineTo(22.975f, 11.778f)
                lineTo(23.95f, 12.445f)
                lineTo(22.782f, 12.623f)
                lineTo(22.868f, 13.802f)
                lineTo(22f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(24f, 5f)
                lineTo(23.132f, 5.802f)
                lineTo(23.218f, 4.623f)
                lineTo(22.05f, 4.445f)
                lineTo(23.025f, 3.777f)
                lineTo(22.436f, 2.753f)
                lineTo(23.566f, 3.099f)
                lineTo(24f, 2f)
                lineTo(24.434f, 3.099f)
                lineTo(25.564f, 2.753f)
                lineTo(24.975f, 3.777f)
                lineTo(25.95f, 4.445f)
                lineTo(24.782f, 4.623f)
                lineTo(24.868f, 5.802f)
                lineTo(24f, 5f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(29f, 9f)
                lineTo(28.132f, 9.802f)
                lineTo(28.218f, 8.623f)
                lineTo(27.05f, 8.445f)
                lineTo(28.025f, 7.777f)
                lineTo(27.436f, 6.753f)
                lineTo(28.566f, 7.099f)
                lineTo(29f, 6f)
                lineTo(29.434f, 7.099f)
                lineTo(30.564f, 6.753f)
                lineTo(29.975f, 7.777f)
                lineTo(30.95f, 8.445f)
                lineTo(29.782f, 8.623f)
                lineTo(29.868f, 9.802f)
                lineTo(29f, 9f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(25f, 22f)
                lineTo(24.132f, 22.802f)
                lineTo(24.218f, 21.624f)
                lineTo(23.05f, 21.445f)
                lineTo(24.025f, 20.778f)
                lineTo(23.436f, 19.753f)
                lineTo(24.566f, 20.099f)
                lineTo(25f, 19f)
                lineTo(25.434f, 20.099f)
                lineTo(26.564f, 19.753f)
                lineTo(25.975f, 20.778f)
                lineTo(26.95f, 21.445f)
                lineTo(25.782f, 21.624f)
                lineTo(25.868f, 22.802f)
                lineTo(25f, 22f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(28.5f, 14.25f)
                lineTo(27.618f, 14.714f)
                lineTo(27.787f, 13.732f)
                lineTo(27.073f, 13.036f)
                lineTo(28.059f, 12.893f)
                lineTo(28.5f, 12f)
                lineTo(28.941f, 12.893f)
                lineTo(29.927f, 13.036f)
                lineTo(29.213f, 13.732f)
                lineTo(29.382f, 14.714f)
                lineTo(28.5f, 14.25f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun AustraliaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Australia,
            contentDescription = "Australia Flag"
        )
    }
}
